import { Link } from "react-router-dom";
import ItemCard from "../../../components/itemCard";

const ThirdSection = () => {

  const DataCard = [
    {
      imageSrc: require("../../../assets/Devices/device1.png"),
      title: <><span>Cardiovascular<br />Ultrasound</span></>,
      description: <>
        <p>Philips' AI-powered cardiovascular ultrasound platform offers advanced tools for diagnosing structural heart disease, heart failure, and coronary artery disease. It features efficient automation, compact ....</p>
        <br />
        <Link to="product/Cardiovascular" className="text-[#005CB9] text-left">
          <h3 className="text-xl">
            Learn More <i className="fa-solid fa-arrow-right"></i>
          </h3>
        </Link>
      </>,
      direction: "left",
    },
    {
      imageSrc: require("../../../assets/Devices/device2.png"),
      title: <><span>General Imaging<br />Ultrasound</span></>,
      description: <>
        <p>Designed to empower clinical decisions, enhance patient experiences and support efficiency, our portfolio of smart, connected General Imaging ultrasound systems deliver people-centric workflows.....</p>
       <br/>
        <Link to="product/General%20Imaging" className="text-[#005CB9] text-left">
          <h3 className="text-xl">
            Learn More <i className="fa-solid fa-arrow-right"></i>
          </h3>
        </Link>      </>,
      direction: "right",
    }, {
      imageSrc: require("../../../assets/Devices/device3.png"),
      title: <><span>Obstetrics and Gynecology Ultrasound</span></>,
      description: <>
        <p>Philips' ultrasound innovations support early detection and confident evaluation in women's health—from pregnancy and routine gynecological care to fertility issues—enabling efficient screening and effective treatment....</p>
        <br/>
        <Link to="product/Obstetrics%20and%20Gynecology" className="text-[#005CB9] text-left">
          <h3 className="text-xl">
            Learn More <i className="fa-solid fa-arrow-right"></i>
          </h3>
        </Link>      </>,
      direction: "left",
    }, {
      imageSrc: require("../../../assets/Devices/device4.png"),
      title: <><span>Point of Care<br />Ultrasound</span></>,
      description: <>
        <p>From handheld devices to premium cart-based systems, our point-of-care portfolio is ergonomic, intuitive and can support a confident diagnosis with a variety of options for any work environment. Our exceptional clinical ....</p>
        <br/>
        <Link to="product/Point%20of%20Care" className="text-[#005CB9] text-left">
          <h3 className="text-xl">
            Learn More <i className="fa-solid fa-arrow-right"></i>
          </h3>
        </Link>
      </>,
      direction: "right",
    },
  ];



  return (
    <div className="App bg-[#D4D8DA]">
      <header className="App-header m-auto md:px-0 md:w-[70%] w-full p-5  py-20 ">
        <div></div>
        <div className="col-span-4 ">
          <div className="mt-5 w-full">
            <h3 className="text-left mb-3 text-[32px] leading-[44.16px] bold">
              Advancing Diagnostic <br />Confidence with Philips Ultrasound Solutions
            </h3>
            <p className="text-[16px] leading-[29.44px] text-left">
              Philips ultrasound solutions enhance patient-focused care by integrating advanced technology with clinicians' needs. Philips' product range—from handheld devices to premium cart-based systems—boosts clinical confidence by enhancing imaging accuracy and performance. Philips offers scalable, reliable solutions supported by shared architecture and comprehensive service programs.
            </p>
          </div>

          <br /><br /><br />
          {DataCard.map((item, index) => (

            <>

              <ItemCard
                imageSrc={item.imageSrc}
                title={
                  <h3 className="text-[32px] leading-[40.64px]">
                    {item.title}
                  </h3>
                }
                description={item.description}
                direction={item.direction}
              />
              <br />
              <hr className="border-gray-color" />
              <br />
            </>

          ))}
       
    
 
      
        </div>
        <div></div>

      </header>
    </div>
  );
};

export default ThirdSection;
